import React from "react";
import { useGetUserInfo } from "api/api-hooks/user-hooks";
import { Tag } from "primereact/tag";

type UserChipProps = {
  id?: string | number,
  username?: string,
}

export default function UserChip({username, id}: UserChipProps) {
  const usernameOrId = id ? Number(id) : username;
  const {data} = useGetUserInfo(usernameOrId, {enabled: !!usernameOrId});

  if(!usernameOrId) {
    return null;
  }

  const displayName = data?.displayName ?? usernameOrId;

  return <Tag value={displayName}/>
}